import PropTypes from 'prop-types';

import { Button } from '@/design-system/atoms/Button';
import { useBreakpoint } from '@/hooks/useBreakpoint';
import { useObserver } from '@/hooks/useObserver';

import { DesktopProviderCarousel } from './components/DesktopProviderCarousel';
import { MobileProviderCarousel } from './components/MobileProviderCarousel';
import styles from './ProviderCarousel.module.scss';

const ProviderCarousel = ({
    title = 'Find a specialist',
    cta,
    ctaPreText = 'Want to see more specialists?',
    providers,
    showCta,
    location,
    ...props
}) => {
    const breakpoints = useBreakpoint();
    const isMobile = !breakpoints?.large;
    // Add useObserver to trigger logic when inView is true
    const { ref, inView } = useObserver({
        triggerOnce: true,
        threshold: 0,
        rootMargin: '400px 0px',
    });

    return providers?.length > 0 ? (
        <section ref={ref} className={styles[`provider-carousel`]} {...props}>
            {inView &&
                (isMobile ? (
                    <MobileProviderCarousel
                        title={title}
                        providers={providers}
                        ctaPreText={ctaPreText}
                        cta={cta}
                        showCta={showCta}
                        location={location}
                    />
                ) : (
                    <DesktopProviderCarousel
                        title={title}
                        providers={providers}
                        ctaPreText={ctaPreText}
                        cta={cta}
                        showCta={showCta}
                        location={location}
                    />
                ))}
        </section>
    ) : (
        <></>
    );
};
ProviderCarousel.propTypes = {
    /**
     * title
     */
    title: PropTypes.string,
    /**
     * CTA Pre-text
     */
    ctaPreText: PropTypes.string,
    /**
     * CTA to overwrite dynamically generated CTA
     */
    cta: PropTypes.shape(Button.propTypes),
    /**
     * whether the CTA should be shown
     */
    showCta: PropTypes.bool,
    /**
     * array of providers
     */
    providers: PropTypes.array,
    /**
     * location to use for distance calculation
     */
    location: PropTypes.string,
};
export default ProviderCarousel;
